import { render } from "./font_modal.vue?vue&type=template&id=27460caf"
import script from "./font_modal.vue?vue&type=script&lang=js"
export * from "./font_modal.vue?vue&type=script&lang=js"

import exportComponent from "/build/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__